module.exports = __webpack_public_path__ + "img/30.fixed_stainless_steel.ef801336.svg";